"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M4 6v36a2 2 0 0 0 2 2h20V28.036h-5.211V22H26v-3.971c0-4.313 2.279-7.562 6.276-7.963a43.068 43.068 0 0 1 5.92.221v5.4h-3.205c-1.27 0-2.981.53-2.981 1.913 0 1.11-.01 4.4-.01 4.4h5.978l-.778 6.038H32V44h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2z" })
);

